if (!customElements.get('sokynd-sticky-cart')) {
  class SokyndStickyCart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
      this.picker = this.section?.querySelector('.js-product variant-picker');
      this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
      this.selects = [...this.querySelectorAll('[data-sticky-option]')];
      this.mainForm = document.getElementById(this.dataset.formId);
      this.input = this.mainForm.querySelector('[name="id"]');
      this.mainButton = this.mainForm.querySelector('[name="add"]');
      this.button = this.querySelector('[name="add"]');
      this.image = this.querySelector('[data-sticky-image]');
      this.trackPreviewBar();
      this.bindPurchase();
      this.bindVisibility();
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-sticky-option]')) return;
        this.selectVariant(Number(event.target.dataset.optionIndex));
      });
      this.section?.addEventListener('on:variant:change', event => {
        if (event.detail.form !== this.mainForm) return;
        this.updateVariant(event.detail.variant, event.detail.selectedOptions);
      });
      if (this.picker?.getSelectedVariant) {
        this.updateVariant(this.picker.getSelectedVariant(), this.picker.getSelectedOptions());
      } else {
        this.updateVariant(this.variants.find(variant => String(variant.id) === this.input.value));
      }
      const reviewLink = this.querySelector('[data-sticky-reviews]');
      reviewLink?.addEventListener('click', event => {
        const reviews = document.querySelector('#looxReviews') || document.querySelector('#loox-reviews, .loox-reviews') || document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, [id*="review_section"]');
        if (!reviews) return;
        event.preventDefault();
        reviews.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      });
    }

    syncPurchase() {
      const busy = this.mainButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = !this.available || this.mainButton.disabled || busy;
      this.button.classList.toggle('is-loading', busy);
      if (busy) this.button.setAttribute('aria-busy', 'true');
      else this.button.removeAttribute('aria-busy');
    }
    bindPurchase() {
      this.button.addEventListener('click', event => {
        event.preventDefault();
        this.syncPurchase();
        if (this.button.disabled) return;
        const error = this.querySelector('[data-cart-error]');
        error.hidden = true;
        error.textContent = '';
        this.mainForm.requestSubmit(this.mainButton);
        this.syncPurchase();
      });
      new MutationObserver(() => this.syncPurchase()).observe(this.mainButton, {attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class']});
      this.section.addEventListener('on:cart:error', event => {
        if (event.target !== this.mainForm.closest('.js-product')) return;
        const error = this.querySelector('[data-cart-error]');
        error.textContent = event.detail.error || '';
        error.hidden = !error.textContent;
        this.syncPurchase();
      });
    }
    bindVisibility() {
      this.footer = document.querySelector('#pagefooter .section-footer, footer.footer');
      if (this.footer) {
        // Dock in a slot above the footer (as SOERA does); a per-frame transform lagged on scroll.
        this.dock = document.createElement('div');
        this.dock.className = 'sokynd-sticky-cart-dock';
        this.footer.before(this.dock);
        this.dock.appendChild(this);
      }
      this.drawerOpen = false;
      this.quickbuyOpen = false;
      const update = () => {
        // 2026-10-25 (ported from SOERA): show the bar only once the buy-box add-to-cart button has scrolled out of the top of the screen, not at a fixed depth.
        const anchor = document.querySelector('.product-form .quantity-submit-row__submit') || document.querySelector('.product-form .add-to-cart');
        const pastButton = anchor ? anchor.getBoundingClientRect().bottom < 0 : scrollY > (innerWidth <= 768 ? 1000 : 300);
        const drawer = document.querySelector('cart-drawer[open]');
        const visible = pastButton && !this.drawerOpen && !this.quickbuyOpen && !drawer;
        this.classList.toggle('visible', visible);
        this.inert = !visible;
        this.setAttribute('aria-hidden', String(!visible));
        if (this.dock) {
          const height = `${Math.ceil(this.getBoundingClientRect().height)}px`;
          if (this.dock.style.height !== height) this.dock.style.height = height;
          const docked = this.dock.getBoundingClientRect().bottom <= innerHeight - (this.previewOffset || 0);
          this.classList.toggle('sokynd-cart-docked', docked);
        }
      };
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; update(); });
      };
      window.addEventListener('scroll', schedule, {passive: true});
      window.addEventListener('resize', schedule);
      document.addEventListener('on:cart-drawer:after-open', () => { this.drawerOpen = true; update(); });
      document.addEventListener('on:cart-drawer:after-close', () => { this.drawerOpen = false; update(); });
      document.addEventListener('on:quickbuy:after-open', () => { this.quickbuyOpen = true; update(); });
      document.addEventListener('on:quickbuy:after-close', () => { this.quickbuyOpen = false; update(); });
      const observer = new ResizeObserver(schedule);
      observer.observe(this);
      observer.observe(document.body);
      update();
    }
    trackPreviewBar() {
      const findFrame = () => {
        const frame = document.getElementById('PBarNextFrame') || document.getElementById('preview-bar-iframe');
        if (!frame) return false;
        const toolbar = document.getElementById('PBarNextFrameWrapper') || frame;
        const updateOffset = () => {
          const rect = toolbar.getBoundingClientRect();
          const offset = rect.width && rect.height ? Math.max(0, innerHeight - rect.top) : 0;
          this.style.setProperty('--sokynd-preview-offset', `${offset}px`);
          this.previewOffset = offset;
        };
        new ResizeObserver(updateOffset).observe(toolbar);
        window.addEventListener('resize', updateOffset);
        updateOffset();
        return true;
      };
      if (findFrame()) return;
      if (window.Shopify?.theme?.role !== 'unpublished' && !new URLSearchParams(location.search).has('preview_theme_id')) return;
      const observer = new MutationObserver(() => {if (findFrame()) observer.disconnect();});
      observer.observe(document.body, {childList: true, subtree: true});
    }
    selectVariant(changedIndex) {
      const options = this.selects.map(select => select.value);
      if (this.picker) {
        const selectors = [...this.picker.querySelectorAll('.option-selector:not(.option-selector--custom)')];
        selectors.forEach((selector, index) => {
          if (selector.dataset.selectorType === 'dropdown') {
            const custom = selector.querySelector('custom-select');
            const option = [...selector.querySelectorAll('.custom-select__option')].find(el => el.dataset.value === options[index]);
            if (custom?.selectOption && option) custom.selectOption(option);
          } else {
            const input = [...selector.querySelectorAll('input')].find(el => el.value === options[index]);
            if (input) input.checked = true;
          }
        });
        const changedSelector = selectors[changedIndex];
        const changedInput = changedSelector?.querySelector('input:checked');
        if (changedInput) changedInput.dispatchEvent(new Event('change', {bubbles: true}));
        else if (changedSelector) this.picker.handleVariantChange({type: 'change', target: changedSelector});
      }
      const variant = this.variants.find(item => item.options.every((value, index) => value === options[index]));
      this.updateVariant(variant, options);
    }
    updateVariant(variant, selectedOptions) {
      const data = variant && this.variants.find(item => item.id === variant.id);
      this.input.value = data ? data.id : '';
      this.available = !!data?.available;
      this.syncPurchase();
      const label = this.querySelector('[data-sticky-button-label]');
      if (label) label.textContent = data?.available ? this.dataset.addText : data ? this.dataset.soldOutText : this.dataset.unavailableText;
      if (selectedOptions) this.selects.forEach((select, index) => { select.value = selectedOptions[index] || ''; });
      if (!data) return;
      this.querySelector('[data-sticky-price]').innerHTML = data.price;
      const compare = this.querySelector('[data-sticky-compare]');
      compare.innerHTML = data.compare;
      compare.hidden = !data.compare;
      if (this.image && data.image) {
        this.image.src = data.image;
        this.image.removeAttribute('srcset');
      }
    }
  }
  customElements.define('sokynd-sticky-cart', SokyndStickyCart);
}
